import api from '@utils/api';

export const login = async (username, password) => {
  if (!username || !password) {
    throw new Error("Usuario y contraseña son requeridos");
  }
  try {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    const { data } = await api.post("/user_management/login", params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    sessionStorage.setItem("username", username);
    return data;
  } catch (error) {
    throw new Error(`Error al iniciar sesión: ${error.message}`);
  }
};
